/**
 * A permission or behavior a player is allowed to do.  Can be permanent, but can also be added or
 * revoked at any time.
 */
export enum Permission {
    /**  Allows the player to play REACH videos. */
    PLAY_REACH_VIDEO = 'play-reach-video',

    /** BrightSign HDMI input URL can be used. */
    BS_HDMI = 'bs-hdmi',

    /** URLs pointing to HLS streams can be used in the SRC attribute of <video> elements. */
    NATIVE_HLS = 'native-hls',

    /** RTSP/RTP URLs can be used in the SRC attribute of <video> elements. */
    NATIVE_RTP = 'native-rtp',

    /** The VLC application can be used to display RTSP/RTP streams. */
    VLC_RTP = 'vlc-rtp',

    /** The VLC application can be used to display RTMP streams. */
    VLC_RTMP = 'vlc-rtmp',

    /** The VLC application can be used to display video from a capture card.  */
    VLC_HDMI = 'vlc-hdmi',

    /**
     * The platform's browser has relaxed security
     * (ie. Allows mixing secure and non-secure iFrames and other things)
     */
    RELAXED_NET_SECURITY = 'relaxed-net-security',

    /**
     * Browsers don't allow sounds to auto-play if a user hasn't interacted with the page. To get
     * around this issue, this permission allows videos to be muted until a user has interacted with
     * the page.
     */
    MUTE_BEFORE_USER_INTERACTION = 'mute-before-user-interaction',

    /** Allows forwarding proof-of-play logs. */
    FORWARD_PROOF_OF_PLAY = 'forward-proof-of-play',
}
